import React, { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { FilterItem, Project } from '../../../utils/models';
import { useAppDispatch } from '../../../store/configureStore';
import { setFilters } from '../../../store/projectsQuery';

import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';

import Conditional from '../../common/conditional';
import Skeleton from '../../common/skeleton';
import LoadingBadge from '../../themed/loading-badge';

import withProjects, { ProjectProps } from '../../hoc/withProjects';
import classNames from './style.module.scss';

const DashboardSearchBar: React.FC<ProjectProps> = ({  dataLength, hasNextPage, fetchNextPage, pages, projectsLoading }) => {
	const [isListVisible, setListVisible] = useState(false);

	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const formRef = useRef<HTMLInputElement>(null);

	const handleNavigateToProject = (project: Project): void => {
		navigate(`/dashboard/projects/${project._id}`);
	};

	const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		const searchFilter: FilterItem = {
			filterName: 'documentNumber',
			filterValue: formRef.current!.value,
			filterMatchType: 'contains'
		};

		dispatch(setFilters([searchFilter]));
	};

	return (
		<div className={classNames.dbSearchBar}>
			<form onSubmit={handleFormSubmit}>
				<div className={classNames.dbSearchBarInput}>
					<input
						type="text"
						ref={formRef}
						onFocus={() => setListVisible(true)}
						onBlur={() => setListVisible(false)}
						placeholder="Search by document number"
						className={classNames.dbSearchBarInputField}
					/>

					<i className="bi bi-search"></i>
				</div>
			</form>

			<Conditional isVisible={projectsLoading}>
				<ul className={classNames.dbSearchBarOptions}>
					{_.range(1, 5).map((page) => (
						<li
							key={page}
							className={classNames.dbSearchBarOption}
						>
							<Skeleton className={classNames.dbSearchBarOptionTitle} />

							<Skeleton />
						</li>
					))}
				</ul>
			</Conditional>

			<Conditional isVisible={isListVisible && pages.length > 0}>
				<ul id="scrollableDiv" className={classNames.dbSearchBarOptions}>
					<InfiniteScroll
						dataLength={dataLength}
						hasMore={hasNextPage}
						next={fetchNextPage}
						loader={<LoadingBadge message='Loading...' />}
						scrollableTarget="scrollableDiv"
					>
						{pages.map((page) => (
							<React.Fragment key={page.currentPage}>
								{page.projects.map((result) => (
									<li
										key={result.documentNumber}
										className={classNames.dbSearchBarOption}
									>
										<p className={classNames.dbSearchBarOptionTitle}>
											<i className="bi bi-info-circle-fill"></i>
											{result.documentNumber}
										</p>

										<button onClick={() => handleNavigateToProject(result)}>
											View Details
										</button>
									</li>
								))}
							</React.Fragment>
						))}
					</InfiniteScroll>
				</ul>

			</Conditional>
		</div>
	);
};

export default withProjects(DashboardSearchBar);
